import React, { useState } from "react";
import RentCollectionList from "./RentCollectionList";
import RentCollectionDetail from "./RentCollectionDetail";
import RentContractDrawer from "../components/host/RentContractDrawer";
/**
 * RentCollectionPage
 * 放置于左侧菜单对应的路由页面中
 * 内部管理 列表 ↔ 详情 的视图切换，无需路由跳转
 */
export default function RentCollectionPage() {
  // view: 'list' | 'detail'
  const [view, setView] = useState("list");
  // 从列表行点击传递过来的记录（含 contractId、contractName、roomNumber 等基础字段）
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [contractModalOpen, setContractModalOpen] = useState(false);
  const [filtersInDetail, setFiltersInDetail] = useState({
    roomNumber: "",
    contractStatus: "focus",
  });
  const [editContract, setEditContract] = useState(null);
  const [detailRefreshKey, setDetailRefreshKey] = useState(0);
  // const [detailFresh, setDetailFresh] = useState(null);

  const handleEnterDetail = (record, filters) => {
    setSelectedRecord(record);
    setFiltersInDetail(filters); // 只含 roomNumber、contractStatus，Detail 不依赖 overdueStatus
    setView("detail");
    window.scrollTo(0, 0); // 详情页从顶部开始
  };

  const handleBack = () => {
    setView("list");
    // 不清空 selectedRecord，方便用户返回后还能看到上次选中位置（如需高亮行可用）
  };
  const showContractModal = (contract) => {
    setEditContract(contract);
    setContractModalOpen(true);
  };
  const hiddenContractModal = () => {
    setContractModalOpen(false);
  };
  const contractChange = (newContract = null) => {
    setContractModalOpen(false);
    if (editContract?._id) setDetailRefreshKey((k) => k + 1); // 编辑保存后通知详情页重新拉数据
    setSelectedRecord(newContract);
    if (newContract) {
      setView("detail");
    }
  };

  return (
    <div style={{ height: "100%", overflow: "clip" }}>
      {view === "list" && (
        <RentCollectionList
          onEnterDetail={handleEnterDetail}
          filters={filtersInDetail}
          showContractModal={showContractModal}
        />
      )}
      {view === "detail" && (
        <RentCollectionDetail
          listRecord={selectedRecord}
          filters={filtersInDetail}
          refreshKey={detailRefreshKey}
          onBack={handleBack}
          showContractModal={showContractModal}
        />
      )}
      <RentContractDrawer
        open={contractModalOpen}
        contract={editContract}
        onCancel={hiddenContractModal}
        onSuccess={contractChange}
      />
    </div>
  );
}
